var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;fill-rule:evenodd;}")),React.createElement("path",{"className":"cls-1","d":"M11.71,10.16H9v3.32h2.71V22h-10A1.18,1.18,0,0,1,.58,20.79V1.26a1.21,1.21,0,0,1,.8-1.2A1.45,1.45,0,0,1,1.79,0H20a3.08,3.08,0,0,1,.53,0,1.19,1.19,0,0,1,.91,1.18V20.79A1.18,1.18,0,0,1,20.28,22H15V13.49h2.7c.14-1.11.27-2.21.41-3.32H15a.2.2,0,0,0,0-.05c0-.79,0-1.58,0-2.37a1.78,1.78,0,0,1,.1-.56,1,1,0,0,1,.81-.69,2.65,2.65,0,0,1,.63-.07h1.66v-3l-.47-.05c-.73,0-1.46-.09-2.18-.07A4,4,0,0,0,13.42,4a3.72,3.72,0,0,0-1.56,2.37,6.15,6.15,0,0,0-.15,1.29v2.53Z","key":1})]);
}

SocialFacebook.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 22 22"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
